import React, { Component } from "react";
import AddCategorie from "./AddCategorie";
import CategorieAll from "./CategorieAll";
import axios from "axios";
import Loader from "../../Loader";

export default class Categorie extends Component {
    state = {
        categories: [],
        loader: true
    }

    componentDidMount() {
        this.getCategories();
    }

    getCategories = async () => {
        try {
            const response = await axios.get('categorie_cvs');
            if (response.status === 200) {
                this.setState({ categories: response.data }, () => {
                    setTimeout(() => {
                        this.setState({ loader: false });
                    }, 3000);
                });
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
            this.setState({ loader: false });
        }
    }

    render() {
        const { categories, loader } = this.state;

        if (loader) {
            return <Loader />;
        }

        return (
            <div className="adminx-content">
                <div className="adminx-main-content">  
                    <div className="container-fluid">
                        <nav aria-label="chapelure" role="navigation">
                            <ol className="breadcrumb adminx-page-breadcrumb">
                                <li className="breadcrumb-item"><a href="#">Accueil</a></li>
                                <li className="breadcrumb-item"><a href="#">Éléments de l’interface utilisateur</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Gestion des categories</li>
                            </ol>
                        </nav>

                        <div className="pb-3">
                            <h1>Gestion des Categoires</h1>
                        </div>

                        <div className="row">
                            <div className="col-lg-8">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <div className="card-header-title">List des Categories</div>
                                    </div>
                                    <div className="card-body collapse show" id="card1">
                                        <CategorieAll cate={categories} func={this.getCategories} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-header-title">Ajouter un utilisateur</div>
                                    </div>
                                    <AddCategorie fonc={this.getCategories} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
